import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { AuthService } from '../../../shared/cardholders-core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigsService } from '../../../config/app-configs.service';
import { MainLayoutService } from '../../main-layout/services/main-layout.service';
import { isNullOrUndefined } from 'core-max-lib';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
    title: string;
    subTitle1: string;
    subTitle2: string;
    showTitle = false;

    constructor(
        private route: ActivatedRoute,
        protected userLoginService: LoginService,
        private appConfigs: AppConfigsService,
        private authSvc: AuthService,
        private mainLayoutService: MainLayoutService,
        protected router: Router
    ) {
        this.authSvc.logoff().subscribe(() => {
            this.mainLayoutService.changeUserBoxMode(false);
        });
        const state = this.router.getCurrentNavigation()?.extras?.state;
        if (state && state.id && state.id !== '') {
            this.showTitle = true;
            this.title = 'שלחנו לך קוד חד פעמי לנייד,';
            this.subTitle1 = 'נשמח לקבל אותו בחזרה כדי לתת לך הצעה להלוואה.';
            this.subTitle2 = 'לא קיבלת את הקוד אפשר להזדהות גם עם שם משתמש וסיסמה.';
        }
    }

    ngOnInit() {
        this.userLoginService.setIsLoginPage(true);
        let returnURL = this.route.snapshot.queryParams['ReturnURL'];
        const queryParamMap = this.route.snapshot['queryParamMap'];

        if (!isNullOrUndefined(returnURL)) {
            const keys = queryParamMap.keys.filter(
                (key) => key !== 'ReturnURL' && key !== 'Focus' && key !== 'IsAutoLoginFailed'
            );

            if (keys.length > 0) {
                let isFirst = true;
                keys.forEach((key) => {
                    returnURL += `${isFirst && !returnURL.includes('?') ? '?' : '&'}${key}=${
                        this.route.snapshot.queryParams[key]
                    }`;
                    isFirst = false;
                });
            }
        }

        this.userLoginService.setLoginPageReturnUrl(returnURL);
    }
}
